import { FC, memo } from 'react';
import { Card } from '@mofid-securities/uikit';
import ReactMarkdown from 'react-markdown';
import { AIWriter } from '@/components/AIWriter';
import { Icon } from '@/components/atomic/Icon';
import { useGetFundDetailSummerize } from '../hooks/useGetFundDetailSummerize';
import { Skeleton } from './Skeleton';

const Writer: FC = memo(() => {
  const { flatData, isLoading } = useGetFundDetailSummerize();

  return (
    <Card
      className="relative mt-2 !bg-[#F0F2F5] text-[14px] leading-6  text-[#565F6B] nested-child-ul:mr-2 nested-child-ul:list-inside nested-child-ul:list-disc"
      padding={16}
      radius="md"
    >
      <Icon
        className="absolute  left-4 top-4 animate-shakeRotate"
        color="#004B69"
        icon="ai"
        size={16}
      />
      {isLoading ? (
        <Skeleton />
      ) : (
        <div className="mt-7">
          <AIWriter delay={30}>
            <ReactMarkdown>{flatData}</ReactMarkdown>
          </AIWriter>
        </div>
      )}
    </Card>
  );
});

Writer.displayName = 'Writer';

export { Writer };
